<script setup>
/******************************************************************************
 * Component for router view / page main
 *****************************************************************************/
</script>

<template>
    <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transitionName" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<style lang="scss" scoped>
.right-enter-active,
.right-leave-active,
.left-enter-active,
.left-leave-active {
    transition:
        opacity get($timings, "fast") ease,
        transform get($timings, "fast") ease;
}

.right-leave-to,
.left-enter-from {
    opacity: 0;

    transform: translateX(-100%);
}

.right-enter-from,
.left-leave-to {
    opacity: 0;

    transform: translateX(100%);
}
</style>
